export const GET_GROUPS = 'GET_GROUPS';
export const GET_GROUP_BY_ID = 'GET_GROUP_BY_ID';
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const DELETE_GROUP = 'DELETE_GROUP';
export const CREATE_GROUP = 'CREATE_GROUP';
